import { render, staticRenderFns } from "./importTask.vue?vue&type=template&id=53b5fa92&scoped=true"
import script from "./importTask.vue?vue&type=script&lang=js"
export * from "./importTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5fa92",
  null
  
)

export default component.exports